<template>
  <a-row :gutter="24" class="new-row">
    <a-col :md="5" :sm="24" class="new-col">
      <a-card :bordered="false" class="new-tree-card">
          <div style="background: #fff;padding-left:16px;height: 100%; margin-top: 5px">
            <a-alert type="info" :showIcon="true">
              <div slot="message">
                {{ $t('当前选择：') }}<span v-if="this.currSelected.title">{{ getCurrSelectedTitle() }}</span>
                <a v-if="this.currSelected.title" style="margin-left: 10px" @click="unselect">{{ $t('取消选择') }}</a>
              </div>
            </a-alert>
            <div style="display: flex;margin-top: 10px;">
              <a-input-search v-model="searchAreaValue" style="width:100%;margin-right: 5px;" allowClear :placeholder="$t('请输入区域名称')"/>
              <a-button type="default" @click="collapseAll">{{ $t('折叠') }}</a-button>
            </div>
            <!-- 树-->
            <a-col :md="24" :sm="24" class="new-tree-col">
              <template>
                <a-spin tip="Loading..." :spinning="areaLoading">
                  <!--
                  <span style="user-select: none">
                    <a-tree
                      class="my-area-select-tree"
                      @select="onSelect"     
                      :selectedKeys="selectedKeys"
                      :treeData="areaTree"
                      :checkStrictly="checkStrictly"
                      :expandedKeys="iExpandedKeys"
                      :autoExpandParent="autoExpandParent"
                      @expand="onExpand">
                      <template slot="title" slot-scope="{title}">
                        <span v-if="title.indexOf(searchAreaValue) > -1">
                          {{title.substr(0, title.indexOf(searchAreaValue))}}
                        <span style="color: #32CD32">{{searchAreaValue}}</span>
                          {{title.substr(title.indexOf(searchAreaValue) + searchAreaValue.length)}}
                        </span>
                        <span v-else>{{title}}</span>
                      </template>
                    </a-tree>
                    </span>
                    -->
                    <el-tree
                      class="filter-tree"
                      :data="areaTree"
                      :props="defaultProps"
                      :expand-on-click-node="false"
                      :filter-node-method="filterNode"
                      :check-on-click-node="true"
                      :check-strictly="checkStrictly"
                      :highlight-current="true"
                      node-key="id"
                      :current-node-key="currentNodeKey"
                      :default-expanded-keys="iExpandedKeys"
                      @node-click="nodeClick"
                      ref="areaTree">
                    </el-tree>
                </a-spin>
              </template>
            </a-col>
          </div>
      </a-card>
    </a-col>
    <a-col :md="19" :sm="24" class="new-col">
      <a-card :bordered="false" class="new-table-card">
        <div class="page-header-index-wide">
          <a-row :gutter="24">
            <a-col :sm="24" :md="12" :xl="8" :style="{ marginBottom: '10px' }">
                <Echart ref="option" :options="option" class="echart"></Echart>
            </a-col>
            <a-col :sm="24" :md="12" :xl="8" :style="{ marginBottom: '10px' }">
                <Echart ref="option2" :options="option2" class="echart"></Echart>
            </a-col>
            <a-col :sm="24" :md="12" :xl="8" :style="{ marginBottom: '10px' }">
                <Echart ref="option3" :options="option3" class="echart"></Echart>
            </a-col>
            <a-col :sm="24" :md="12" :xl="8" :style="{ marginBottom: '10px' }">
                <Echart ref="option4" :options="option4" class="echart"></Echart>
            </a-col>
          </a-row>
        </div>
      </a-card>
    </a-col>
  </a-row>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { putAction } from '@/api/manage'
  import moment from 'moment'
  import {AreaChoosetMixin} from '@/mixins/AreaChooseMixin'
  import echarts from 'echarts/lib/echarts';
  export default {
    name: 'meterReportingRateList',
    mixins:[JeecgListMixin, mixinDevice, AreaChoosetMixin],
    components: {
    },
    data () {
      return {
        description: 'meter_up_data_analysis管理页面',
        tabs:'',
        DayPieData:[ ],
        date:[],
        dayrepor:0,
        threerepor:0,
        sevenrepor:0,
        dataSource:{
          curDayMeterReportCount:0,
          lastSevenDayMeterReportCount:0,
          lastThreeDayMeterReportCount:0,
          meterTotalCount:0,
        },
        // 表头
        url: {
          list: "/jeecg-charge/meter/waterAnalysis/meterReportingRate",
          delete: "/jeecg-charge/meter/meterUpDataAnalysis/delete",
          deleteBatch: "/jeecg-charge/meter/meterUpDataAnalysis/deleteBatch",
          exportXlsUrl: "/jeecg-charge/meter/meterUpDataAnalysis/exportXls",
          importExcelUrl: "jeecg-charge/meter/meterUpDataAnalysis/importExcel",
        },
        dictOptions:{},
        option: {},
        option2: {},
        option3: {},
        option4: {},
      }
    },
    created() {
      this.$store.commit('SET_LAYOUT_TREE',true)
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      // i18n：图例使用 computed 以响应语言切换
      DayPieFields () {
        return ['昨日', '今日'].map(item => this.$t(item))
      },
      // i18n：表头使用 computed 以响应语言切换
      columns () {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t, r, index) => {
              return parseInt(index)+1;
            }
          },{
            title: this.$t('用户编号'),
            align:"center",
            dataIndex: 'userId'
          },{
            title: this.$t('用户姓名'),
            align:"center",
            dataIndex: 'userName'
          },{
            title: this.$t('表编号'),
            align:"center",
            dataIndex: 'meterId'
          },{
            title: this.$t('表安装地址'),
            align:"center",
            dataIndex: 'userAddr'
          },{
            title: this.$t('用户手机'),
            align:"center",
            dataIndex: 'userPhone'
          },{
            title: this.$t('用户地址'),
            align:"center",
            dataIndex: 'userMeterAddr',
          },{
            title: this.$t('定时上传'),
            align:"center",
            dataIndex: 'upWay0MeterCount',
          },{
            title: this.$t('上电上传'),
            align:"center",
            dataIndex: 'upWay1MeterCount'
          },
          {
            title: this.$t('手动上传'),
            align:"center",
            dataIndex: 'upWay2MeterCount'
          },
          {
            title: this.$t('故障上传'),
            align:"center",
            dataIndex: 'upWay3MeterCount'
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:100,
            scopedSlots: { customRender: 'action' }
          }
        ]
      },
    },
    methods: {
      loadData(arg) {
        if(!this.url.list){
          this.$message.error(this.$t("请设置url.list属性!"))
          return
        }
        //加载数据 若传入参数1则加载第一页的内容
        if (arg === 1) {
          this.ipagination.current = 1;
        }
        var params = this.getQueryParams();//查询条件
        params.beginDate = this.date.Start
        params.endDate = this.date.End
        this.loading = true;
        putAction(this.url.list, params).then((res) => {
          if (res.success) {
            this.dataSource = res.result;
            this.ipagination.total = res.result.total;
            console.log(this.dataSource.curDayMeterReportCount==0)
             if (this.dataSource.meterTotalCount==0) {
              this.dayrepor = 0+'%'
              this.threerepor = 0+'%'
              this.sevenrepor = 0+'%'
               console.log('出来呢');
             } else {
              this.dayrepor = ((Number(this.dataSource.curDayMeterReportCount)/Number(this.dataSource.meterTotalCount))*100).toFixed(2)+'%'
              this.threerepor = ((Number(this.dataSource.lastThreeDayMeterReportCount)/Number(this.dataSource.meterTotalCount))*100).toFixed(2)+'%'
              this.sevenrepor = ((Number(this.dataSource.lastSevenDayMeterReportCount)/Number(this.dataSource.meterTotalCount))*100).toFixed(2)+'%'
              console.log('也出来呢');
              this.setOption(1)
              this.setOption(2)
              this.setOption(3)
              this.setFkStatusOption()
             }
          }
          if(res.code===510){
            this.$message.warning(res.message)
          }
          this.loading = false;
        })
      },
      onChange(value, dateStrings) {
        console.log(this.date);
        this.date.Start = moment(dateStrings[0]).format('YYYY-MM-DD');
        this.date.End = moment(dateStrings[1]).format('YYYY-MM-DD');
      },
      onOk(value) {
        console.log('onOk:', value);
      },
      setOption(flag) {
        var dataArr = 80;
        var colorSet = {
            color: '#468EFD'
        };
        var text;
        if(flag == 1) {
          text = `${this.$t('今日上报率')}${this.dayrepor}\n ${this.dataSource.curDayMeterReportCount}/${this.dataSource.meterTotalCount}`
        }else if(flag == 2) {
          text = `${this.$t('近三天上报率')}${this.threerepor}\n ${this.dataSource.lastThreeDayMeterReportCount}/${this.dataSource.meterTotalCount}`
        }else if(flag == 3) {
          text = `${this.$t('近七天上报率')}${this.sevenrepor}\n ${this.dataSource.lastSevenDayMeterReportCount}/${this.dataSource.meterTotalCount}`
        }
        var option = {
            backgroundColor: "#e6f7ff",
            title: {
                show: true,
                text: text,
                x: '49%',
                y: '80%',
                z: 8,
                textAlign: 'center',
                textStyle: {
                    color: '#4FADFD',
                    fontSize: 18,
                },

            },
            series: [
                {
                    name: this.$t("内部进度条"),
                    type: "gauge",
                    // center: ['20%', '50%'],
                    radius: '55%',
                    splitNumber: 10,
                    axisLine: {
                        lineStyle: {
                            color: [
                                [dataArr / 100, colorSet.color],
                                [1, "#111F42"]
                            ],
                            width: 12
                        }
                    },
                    axisLabel: {
                        show: false,
                    },
                    axisTick: {
                        show: false,

                    },
                    splitLine: {
                        show: false,
                    },
                    data:[{value: dataArr}],
                    pointer: {
                        show: false,
                    },
                },
                {
                    name: this.$t('外部刻度'),
                    type: 'gauge',
                    //  center: ['20%', '50%'],
                    radius: '70%',
                    min: 0, //最小刻度
                    max: 100, //最大刻度
                    splitNumber: 10, //刻度数量
                    startAngle: 225,
                    endAngle: -45,
                    axisLine: {
                        show: true,
                        lineStyle: {
                            width: 1,
                            color: [
                                [1, 'rgba(0,0,0,0)']
                            ]
                        }
                    },
                    //仪表盘轴线
                    axisLabel: {
                        show: true,
                        color: '#4d5bd1',
                        distance: 25,
                        formatter: function (v) {
                            switch (v + '') {
                                case '0':
                                    return '0';
                                case '10':
                                    return '10';
                                case '20':
                                    return '20';
                                case '30':
                                    return '30';
                                case '40':
                                    return '40';
                                case '50':
                                    return '50';
                                case '60':
                                    return '60';
                                case '70':
                                    return '70';
                                case '80':
                                    return '80';
                                case '90':
                                    return '90';
                                case '100':
                                    return '100';
                            }
                        }
                    }, //刻度标签。
                    axisTick: {
                        show: true,
                        splitNumber: 7,
                        lineStyle: {
                            color: colorSet.color, //用颜色渐变函数不起作用
                            width: 1,
                        },
                        length: -8
                    }, //刻度样式
                    splitLine: {
                        show: true,
                        length: -20,
                        lineStyle: {
                            color: colorSet.color, //用颜色渐变函数不起作用
                        }
                    }, //分隔线样式
                    detail: {
                        show: false
                    },
                    pointer: {
                        show: false
                    }
                },
                /*内部*/
                {
                    type: 'pie',
                    radius: ['0', '30%'],
                    center: ['50%', '50%'],
                    z: 8,
                    hoverAnimation: false,
                    data: [{
                        name: this.$t('上报率'),
                        value: '80',
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                                    offset: 0,
                                    color: '#4FADFD'
                                }, {
                                    offset: 1,
                                    color: '#28E8FA'
                                }])
                            }

                        },
                        label: {
                            normal: {
                                rich: {
                                    a: {
                                        color: '#ffffff',
                                        align: 'center',
                                        fontSize: 40,
                                        fontWeight: "bold"
                                    },
                                },
                                formatter: function (params) {
                                    return "{a|" + params.value + "}";
                                },
                                position: 'center',
                                show: true
                            }
                        },
                        labelLine: {
                            show: false
                        }
                    }],
                },
                /*外一层*/
                {
                    type: "pie",
                    radius: "35%",
                    startAngle: 220,
                    endAngle: -40,
                    hoverAnimation: false,
                    center: ["50%", "50%"],
                    avoidLabelOverlap: false,
                    label: {
                        show: false
                    },
                    labelLine: {
                        show: false
                    },
                    data: [{
                        value: 1
                    }],
                    itemStyle: {
                        normal: {
                            color: {
                                type: "linear",
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [{
                                    offset: 0,
                                    color: "rgba(69, 161, 255,0.8)"
                                }, {
                                    offset: 1,
                                    color: "rgba(69, 161, 255,0.5)"
                                }]
                            }
                        }
                    }
                },
                //外二层圈
                {
                    type: "pie",
                    radius: "40%",
                    center: ["50%", "50%"],
                    avoidLabelOverlap: false,
                    z: 0,
                    hoverAnimation: false,
                    label: {
                        show: false
                    },
                    labelLine: {
                        show: false
                    },
                    data: [{
                        "value": 1
                    }],
                    itemStyle: {
                        normal: {
                            color: {
                                type: "linear",
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [{
                                    offset: 0,
                                    color: "rgba(69, 161, 255,0.5)"
                                }, {
                                    offset: 1,
                                    color: "rgba(69, 161, 255,0.38)"
                                }]
                            }
                        }
                    }
                },
                //最外层圈
                {
                    type: "pie",
                    radius: "45%",
                    center: ["50%", "50%"],
                    avoidLabelOverlap: false,
                    z: 0,
                    hoverAnimation: false,
                    label: {
                        show: false,
                    },
                    labelLine: {
                        show: false
                    },
                    data: [{
                        value: 1
                    }],
                    itemStyle: {
                        normal: {
                            color: {
                                type: "linear",
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [{
                                    offset: 0,
                                    color: "rgba(69, 161, 255,0.3)"
                                },
                                    {
                                        offset: 1,
                                        color: "rgba(69, 161, 255,0)"
                                    }
                                ]
                            }
                        }
                    }
                }
            ]
        };
        if(flag == 1) {
          this.option = option
        }else if(flag == 2) {
          this.option2 = option
        }else if(flag == 3) {
          this.option3 = option
        } 
      },
      setFkStatusOption() {
        var img = 'data:image/png;base64,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';
        const man =
            'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAANsAAADICAYAAABhwZR1AAARjElEQVR4Xu2dD4wc5XnG33fufN7Zc21HSgJF9cVKQqOmiChNAnHrKCARC2MI3lljQqmCIxFKEifFeGcdI1CuLcX45sAO2Eloi6hoStDZN4tDgyAOgohEKK5wLQVCwKlQTEIjRRW2a+/M+W7nrdZgF8z92dndb95v7p6TLCRuvvd55vd9P69vb/eOKeOPex6ThSfqY8sa3FjmOM4nSWgZES3MuAbi5hwBPsxMT1OS/EQSfi7pO/bcpivf879ZYuAsw4LReBWRbCemD2aZiywQmITAb5j47opX2JYVncxkGwrjCpMEWd0YckCgRQLP0rEjn/E/f/bxFq9v+7JMZAvC6FUi+qO2W2IhCBgm0MvxuzaU3nXYZIxx2YIweoqILjJ5E5gNAl0g8LjvuSu7MGfKEUZlGx6NvywsO03eAGaDQLcIJElS2rSm/5FuzTtzjjHZ7hmR94z1xs8S0QdMlcdcEOguAT7Qy9HFpv45aUy2IKx/joi/110YmAYChgkwXe+X3PtNpBiTbevo8UGHnW+YKI2ZIGCMgND9ftm93sR8Y7IFYbyLSNaYKI2ZIGCKABO/UPEK55mYb062WnSQBN+8NrFpmGmWwPyJwnu/tpZ/3+0Uc7KFUfOlMAu6XRjzQMA0AZHkY9Vy//5u55iU7RkiWt7twpgHAoYJHPU9d5GJDHOy1eJ7SWS9idKYCQLGCDA94ZfcS03MNyhbfT0J32uiNGaCgCkCiSR/u6ncP2hivjHZtobHPuNQzw9NlMZMEDBFgBO+tLKm8ISJ+cZka5bF0/8mtgwzjRFg3u6XChtMzTcq27ZR+cMJjl8zVR5zQaCbBEy/8t+obE0QeCVJN48DZpkiIETXVT33QVPzm3ONy9YMGQ6jfxCiW0zeCGaDQLsEmOlfKiX3C+2ub3VdJrI1y2ypRUvnEX1DhNa1Wg7XgYBJAs2XZrFD1Y2rC4+ZzDk1OzPZTgUOjUbr2OHLmWS5CJ2VxU0iAwT+nwAfJqZnkqSx39RT/FPRzly2txa5e8+JjzeSZHmSNBbP9ePgsPNpQ+9ofzqR5Mdzni/xYXbkmUqp/zktFqqyad20jbmmnkgy+U1aGzna3AmyWbI7kM2SjTBYA7IZhJtmNGRLQyuf10I2S/YNslmyEQZrQDaDcNOMhmxpaOXzWshmyb5BNks2wmANyGYQbprRkC0NrXxeC9ks2TfIZslGGKwB2QzCTTMasqWhlc9rIZsl+wbZLNkIgzUgm0G4aUZDtjS08nktZLNk3yCbJRthsAZkMwg3zWjIloZWPq+FbJbsG2SzZCMM1oBsBuGmGQ3Z0tDK57WQzZJ9g2yWbITBGpDNINw0oyFbGlr5vBayWbJvkM2SjTBYA7IZhJtmNGRLQyuf10I2S/YNslmyEQZrQDaDcNOMhmxpaOXzWshmyb5BNks2wmANyNZFuEO7jq2gHud8Zj6fEvkINf+buw8+wCwHkkRe7Ol1frnxysL3c3cLlhaGbF3amKAWbSahO7o0zqIxvJtFKpWy+2uLSuWyCmTrcNu21WTxhMTNv/0/1eEoe5czvUYkG/xSccTekvY3g2wd7NG20fj9Eyz/1cGIfC1l+apfKu7IV2l72kK2DvYiCOuHiHhJByNytlRedRz6i42ri6/mrLgVdSFbm9sQjNbvJeb1bS7P7zKRHX65+NX83oBec8jWBvu5/vvCE2qs2OQt2NsGujm9BLK1sf1z9lHtFCuh+/2ye30b6Ob0EsjWxvYHtWgvCV3SxtJZsaT5SwQrXuG8WXEzGd4EZGsDdhBGvyeid7exdNYsSUSWbCoXfzNrbiiDG4FsKSHf9Uh9SZLwoZTLZt3lQrK26hV3zbobM3hDkC0l3GBXdBH10FMpl826y/FLFtNvKWRLyQyyvQEMsqU8OEQE2VIyg2yQLeWROX05ZEtJDrJBtpRHBrK1CwyyQbZ2zw4e2VKSg2yQLeWRwSNbu8AgG2Rr9+zgkS0lOcgG2VIeGTyytQsMskG2ds8OHtlSkoNskC3lkcEjW7vAIBtka/fsdO2R7c4RWUQULerr61mUJI1FTk9vPOEkR3h8/pH5BTrytct4rN2SNq2DbLNPtqzObtuy3TlSH3DmOatYZBURNf9M+9F8W0ZDGruZeG+1XPzpTNfb+nnIln/ZtM5uatmGavEKTpL1xHxFB0K8xEzfHa+P7dx87eLXO5iT+VLIll/ZunV2E0ke7qPifRvK/N9pDmDLsgVhfRkTf0WIrk0TMMO1B4Vl59Jxd8fatdzo4lxjoyDbG2iZ+OaKV9hmDHQXBxs5u0yvJUnyT2mka0m2YDS6g5g2d/H+zxgl+x3m6saS+6S5jO5MHn7o6LulMK/55tE5/iF/7nvFZ22HMDQa/T0z3WqsZ/NnaibJ3/nl/vtmyphWtsER6VswL75PhNbNNKjjzzNPkMgNvuc+0PEswwOGw+gVIVpqOMbm8Ud9z11kc8Fmt+Ew3i4kf5NNT77H9wrTZk0p25ZatLSX+HkS6c+m7KkUrvpeIcg2M13a0Gh9DzN/Nt2qWXQ10xN+yb3U5jsKwvg5IvmzTDsyP+qXClOei0llG9odn8uOvJxp0beECdF1Vc99UCt/ptzhWrxVRKozXTdbP2/7G0eDWnws+weJN3eb+X6/VJj0J49NKltQi35LQueoHpYGXexf5T6t2mGK8OFHxj4sSdL8emWhjf2MdmL5z+O9h5cPXnFO3WhOm8ODMNpHRJ9oc3l3lrFcPdnvRXiHbEEY7yKSNd1J7WQKnxBxllXLffs7mWJqranfp2aqb/fmyjW+V3y4e/O6N2m4Fj2QyfMLLVQWkeVnfj/5bbINh/GNQvLtFmZldInsf9+Ee4Gt3xYYDuPnheRPM4JhQYw87HvFaywo8o4KeTi7p2UbfFSK/eNjPyMSq374prDcVC0Vv2njBjc7BWHU/ElbF9nar1u9ROipHuYbN3oFta/lp7qXvJzd07IFYewTyVC3NqeLcw5ORGMX2vxKk6HR+tXMbOU/rbqyD0xb/JJ7S1dmGRiSl7N7Urbte+Ss8Yl4HzENGGDR8Uhmuq1Scm/veJDBAW88g0tbiWQlERUMRmU0mg8TyQsO8Z0bvcK/ZxSaOiZPZ/ekbMHo8b8mdr6T+k6zW/Cy77kfyi6u/aTBB6RQXHT8Iod6Pk3EH2hI4xftT1NYKXSA5vW8uOnKwksK6akj83R235Qt+jdi+svUd5rhAib5VMUr/iTDSETlgEAwmp+zyyMj0vPr3vgwES2wma0I3V4tu7fZ3BHdsiWQt7PLwWh8CbHk4Rfb/YfvuRdku51Is5lA3s4uD4fRFiH6us1QT3U7fqTgDn6B4zx0RUfzBPJ2djkIo+8R0efMo+k8gRPnTypr5v+y80mYMBsI5O3sNh/ZnhWiT+YBvlBjZdVb8HgeuqKjeQJ5O7vNR7bmW7vPNo+m84SEki9t8vpt/hZF5zeJCS0TyNvZbcomLd+d8oW2v7VDGc+ci8/b2Z01sq24NakRyZz9pfKz1LTv//D2nil/5g1kM7jr0z2yvSnbaoPxGJ09gYcgW/bQTyZCNiXwerGQTYs9ZNMir5YL2bTQQzYt8mq5kE0LPWTTIq+WC9m00EM2LfJquZBNCz1k0yKvlgvZtNBDNi3yarmQTQs9ZNMir5YL2bTQQzYt8mq5kE0LPWTTIq+WC9m00EM2LfJquZBNCz1k0yKvlgvZtNBDNi3yarmQTQs9ZNMir5YL2bTQQzYt8mq5kE0LPWTTIq+WC9m00EM2LfJquZBNCz1k0yKvlgvZtNBDNi3yarmQTQs9ZNMir5YL2bTQQzYt8mq5kE0LPWTTIq+WC9m00EM2LfJquZBNCz1k0yKvlgvZtNBDNi3yarmQTQs9ZNMir5YL2bTQQzYt8mq5kE0LPWTTIq+WC9m00EM2LfJquZBNCz1k0yKvlgvZtNBDNi3yarmQTQs9ZNMir5YL2bTQQzYt8mq5kE0LPWTTIq+WC9m00EM2LfJquZBNCz1k0yKvlgvZtNBDNi3yarmQTQs9ZNMir5YL2bTQQzYt8mq5kE0LPWTTIq+WC9m00EM2LfJquZBNCz1k0yKvlgvZtNBDNi3yarmQTQs9ZNMir5YL2bTQQzYt8mq5kE0LPWTTIq+WC9m00EM2LfJquZBNCz1k0yKvlgvZtNBDNi3yarmQTQs9ZNMir5YL2bTQQzYt8mq5kE0LPWTTIq+WC9m00EM2LfJquZBNCz1k0yKvlgvZtNBDNi3yarmQTQs9ZNMir5YL2bTQQzYt8mq5kE0LPWTTIq+WC9m00EM2LfJquZBNCz1k0yKvlgvZtNBDNi3yarmQTQs9ZNMir5YL2bTQQzYt8mq5kE0LPWTTIq+WC9m00EM2LfJquZBNCz1k0yKvlgvZtNBDNi3yarmQTQs9ZNMir5YL2bTQQzYt8mq5kE0LPWTTIq+WC9m00EM2LfJquZBNCz1k0yKvlgvZtNBDNi3yarmQTQs9ZNMir5YL2bTQQzYt8mq5kE0LPWTTIq+WC9m00EM2LfJquZBNCz1k0yKvlgvZtNBDNi3yarmQTQs9ZNMir5YL2bTQQzYt8mq5kE0LPWTTIq+WC9m00EM2LfJquZBNCz1k0yKvlgvZtNBDNi3yarmQTQs9ZNMir5Y7u2QbrkW/E6Gz1HCmCBbmL1dLhW9PtmTFrUmNSFanGIdL7ScwrWy5OrvEPgdhtI+IPmE/dyISvtwvF34A2XKxW90oOdMjW37OLtENHNTi3SRS7gYZ0zN6HOf8m1fP//lkOZcNytmm8zE/ewKPDfLvpkrN09kldq7m4TC+W0g2ZI8xfWJjorD462v5SPqVWDEbCeTp7LLDl/JQWL+KiUds3wwmfrniFT5ke0/0y47A0Gi0jpkeyC6x/aREZAlv3SN/4DTio+2PyWYlE2+reIWbs0lDSh4I3BXGf5yQvGR/Vznge8WPcrPocBiPCMlVNpd2mC7ZWHKftLkjumVPYDiMXhGipdknp0nkwPcK1ZOyDe0+/iV2nG+lWZ7ptUK/8svuuZlmIiwXBIbC6CEmusbmsky8ouIV9p6UbfseOWt8It5HTAM2lmam2yol93Ybu6GTLoEgPP5FIucfdVtMnc5E+yqee2HzipOyNT+CMPaJZMjC0gcnorELN1+7+HULu6GSBQSCsP4MES+3oMo7KgjRdVXPffBtsg0+KsX+8bGfEcl5NpUWlpuqpeI3beqELnYRuOuR+tVJwg/b1YpIiJ6seu4lp3qdfmRr/o/hML5RSCZ9OZTOjcj+9024F6xdyw2dfKTmhUBQi35AQpdZ1VfE88vF2qSyvfnPyV1Eska/NJ8QcZZVy3379bugge0EgrC+jIgfJ6KFVnRl2uKX3Fve2uVtj2ynv36rRb8loXNUSzfoYv8q92nVDgjPFYGgFv0VCf2rdmkm+ueK537xzB6Tyja0Oz6XHXlZq/Rbv6jU6oDcfBIIavFNJLJNrb3QK37Zff9k+ZPK1rxwSy1a2kv8PIn0Z1ucq75XCLLNRNpsIhCEdZ+Is39mnfmoXyosmorllLI1FwyOSN+CefF9IrTO+GYwT5DIDb7n5uK1bsZ5IKAjAlm/5leIXqx67oenKz2tbKe/hhuN7iCmzR3d/bSLZb/DXMXLscwRnouTsxJOiPZWPXfFTIxbkq05pPlsDxN/RYiunWlois8fFJadS8fdHXh6PwU1XNoygbvC+PKE6QYSuaLlRa1eyPS6JLSzWnZva2VJy7KdGjZUi1dwkqwn5k7Kv8RM3x2vj+3EK0Na2SZc0ymBLkvXYOIdSVO0NYWDrXZLLdupwXeO1Aecec4qFllFRM0/034w8QsNaexm4r3VcvGnM12Pz4OACQLDtXhlkiQrmXglMX0wXQY/Lpw8RUnvj9r5/m/bsp1Zsilfby8NiPCAsAwQO0c4oUM9PXzoxIm+Q3iHdbptxdXmCdy958THxyfGL+/h3iXNM8tCA0I0wCxHROgQMR9ioUNCyb5xmth7i7fwfzpp9X+sN6/8E/B4OQAAAABJRU5ErkJggg==';
        const woman =
            'data:image/png;base64,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';
        var list = [{
            name: this.$t('开阀'),
            value: this.dataSource.meterValveOpenCount
        }, {
            name: this.$t('关阀'),
            value: this.dataSource.meterValveCloseCount
        }];
        var data = [];
        var total = 0;
        var color = ['#50E3B8','#FECA20']
        for (var i = 0; i < list.length; i++) {
          total= total +list[i].value
            data.push({
                value: list[i].value,
                name: list[i].name,
                itemStyle: {
                  normal: {
                      borderWidth: 5,
                      borderColor: color[i],
                      shadowColor: color[i]
                  }
                }
            },
             {
                value: 2,
                name: '',
                itemStyle: {
                    normal: {
                        label: {
                            show: false
                        },
                        labelLine: {
                            show: false
                        },
                        color: 'rgba(0, 0, 0, 0)',
                        borderColor: 'rgba(0, 0, 0, 0)',
                        borderWidth: 0
                    }
                }
            });
            console.log(list);
        }
        console.log(total)
        var seriesOption = [{
            name: '',
            type: 'pie',
            clockWise: false,
            radius: ['50%', '55%'],
            startAngle:270,
            hoverAnimation: false,
            itemStyle: {
                normal: {
                    label: {
                        show: true,
                        position: [0, -20],
                        textStyle: {
                          fontSize: 16
                        },
                        //color: '#4FADFD',
                        formatter: (params) => {
                          console.log(params);
                            var percent = 0;
                            if (total==0) {
                              percent = 0;
                            } else {
                              percent = ((params.value / total) * 100).toFixed(0);
                            }
                            if (params.name !== '') {
                                return params.name + '\n' +params.value+ this.$t('个') +'\n'+'('+ percent + '%)';
                            } else {
                                return '';
                            }
                        },
                    },
                    labelLine: {
                        length: 10,
                        length2: 15,
                        show: true,
                        //color: '#4FADFD'
                    }
                }
            },
            data: data
        }];
        this.option4 = {
            backgroundColor: '#e6f7ff',
            color: color,
            graphic: {
                elements: [{
                        type: "image",
                        z: 3,
                        style: {
                            image: img,
                            width: 100,
                            height: 100
                        },
                        left: 'center',
                        top: 'center',
                        position: [100, 100]
                    },
                     {
                        type: 'image',
                        z: 3,
                        style: {
                            image: woman,
                            width: 30,
                            height: 30
                        },
                        left: '52%',
                        top: 'center'
                    },
                    {
                        type: 'image',
                        z: 3,
                        style: {
                            image: man,
                            width: 30,
                            height: 30
                        },
                        right: '52%',
                        top: 'center'
                    }
                ]
            },
            tooltip: {
                show: false
            },
            toolbox: {
                show: false
            },
            series: seriesOption
        }
      }
    }
  }
</script>
<style scoped>
  .tables{
    width: 88%;
  }
  .typeface{
    font-size:22px;
    font-weight:normal
  }
  .echart{
    min-height: 250px;
  }
  .my-area-select-tree /deep/ li .ant-tree-node-content-wrapper{
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    white-space: nowrap;
  }
</style>